import { useCallback, useMemo, useState } from 'react';
import { CommonProperties } from '../common/common.interfaces';
import BlobModalComponent from '../blobs/BlobModalComponent';
import { CUSTOM_JSON_THEME } from '../common/common.constants';
import JSONPretty from 'react-json-pretty';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { Arrow90degDown, Arrow90degUp, FileText, Translate } from 'react-bootstrap-icons';
import { useUserContext } from '../user/UserContext';
import { useLoading } from '../loading/LoadingContext';
import { OrdersMcfTableRow } from '../common/common.table.interfaces';
import { apiFetch } from '../utility/fetch';
import { API_PROD_URL } from '..';
import { notify } from '../notify/notify';
import SalsifyTo from './components/SalsifyTo';
import SalsifyFrom from './components/SalsifyFrom';
import SalsifyConfiguration from './components/SalsifyConfiguration';
import SalsifyLocalization from './components/SalsifyLocalization';

interface SalsifySyncProps extends CommonProperties {}

export default function SalsifySync(props: SalsifySyncProps){

  const [modalTitle, setModalTitle] = useState('')
  const [modalContent, setModalContent] = useState('')
  const [modalVisible, setModalVisible] = useState(false)

  const handleShowContent = useCallback((e) => {
    const {title, content} = e.currentTarget.dataset
    setModalTitle(title)
    setModalContent(content)
    setModalVisible(true)
  }, [])

  const view = useMemo(() => {
    return <div>
      {/* <WayfairMcfSearchModal hideModal={() => {setSearchVisible(false)}} row={searchContent} title={searchTitle} visible={searchVisible} /> */}
      <BlobModalComponent raw={modalContent} blobData={<JSONPretty data={modalContent} theme={CUSTOM_JSON_THEME} style={{fontSize: '1.5em'}} />} blobName={modalTitle} closeModal={() => {setModalVisible(false)}} modalVisible={modalVisible === true}/>
      <div id='top'></div>
      <div className='beacon-card'>
        <table className='beacon-table'>
          <tbody>
            <tr>
              <td><span className='beacon-header'>Salsify Sync</span></td>
            </tr>
            <tr>
              <td><span className='beacon-label'>View and manage Salsify Sync product records from Salesforce to Salsify and from Salsify into Salesforce. Manage sync and localization settings here as well.</span></td>
            </tr>
          </tbody>
        </table>
      </div>
      <br/>
      <Tabs>
        <TabList>
          <Tab key='sync-config-tab'><span className='beacon-header'><FileText size={25} />&nbsp;SYNC CONFIGURATIONS</span></Tab>
          <Tab key='localization-tab'><span className='beacon-header'><Translate size={25} />&nbsp;LOCALIZATION FIELDS</span></Tab>
          <Tab key='from-salsify-tab'><span className='beacon-header'><Arrow90degDown size={20} color='green' />&nbsp;FROM SALSIFY ROWS</span></Tab>
          <Tab key='to-salsify-tab'><span className='beacon-header'><Arrow90degUp size={20} color='green' />&nbsp;TO SALSIFY ROWS</span></Tab>
        </TabList>
        
        <TabPanel key='sync-config-tab-panel'>
          <SalsifyConfiguration />
        </TabPanel>
        <TabPanel key='localization-tab-panel'>
          <SalsifyLocalization />
        </TabPanel>
        <TabPanel key='from-salsify-tab-panel'>
          <SalsifyFrom handleShowContent={handleShowContent}/>
        </TabPanel>
        <TabPanel key='to-salsify-tab-panel'>
          <SalsifyTo handleShowContent={handleShowContent}/>
        </TabPanel>

      </Tabs>

    </div>
  }, [modalTitle, modalContent, modalVisible])

  return view
}